// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + ({"933":"monitoring","943":"usecenter","970":"mgtcenter"}[chunkId] || chunkId) + "_" + {"688":"443ae1c5","933":"224dc9b0","943":"de850367","970":"a471af84"}[chunkId] + ".css";
};